import React from "react";

export default function FooterText() {
  return (
    <div className="pt-3 pb-4">
      <h1 className="footer-michigan-logo">M</h1>
      <p className="wolverines-corner-footer footer-text">
        &copy; Wolverines Corner
      </p>
      <p className="go-blue-footer footer-text">Go Blue!</p>
      <p className="email-footer fs-6">
        <a href="mailto:cory@corycox.com">Email Me</a>
      </p>
    </div>
  );
}
